module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.f4769f9bdb7466be65088239c12046d1.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
 ** module id = 384
 ** module chunks = 0
 **/